import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-valorant-duo-games',
  templateUrl: './valorant-duo-games.component.html'
})
export class ValorantDuoGamesComponent {
  service = 'games';
  availableServices = services['valorant'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'valorant',
    service: 'games',
    type: 'duo',
    title: {
      en: 'Duo Games',
    },
    subtitle: {
      en: 'Duo Games with guaranteed Booster performance and no minimum Win Ratio',
      fr: 'Parties en Duo avec garantie de performance du Booster et sans ratio de victoire minimum',
      de: 'Duo-Spiele mit garantierter Booster-Leistung und ohne Mindestgewinnquote',
      pt: 'Duo Games Ranked com desempenho garantido do Booster e sem WR mínimo',
      es: 'Duo Games con Boosters garantizados y sin Win Ratio mínimo',
    }
    ,
    start: DivisionsService.getValueByRank('Silver III', 'valorant'),
    desired: 5,
    serviceName: {
      en: 'Games',
      fr: 'Parties',
      de: 'Games',
      pt: 'Jogos',
      es: 'Juegos'
    },
    min: 1,
    max: 5
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Duo Games Boosting Service?",
        answer: "Duo Games is an elo boosting service that allows you to play alongside one of our boosters for a determined number of games."
      },
      {
        question: "How Many Games Will I Win?",
        answer: "This service does not guarantee victories but rather provides a certain amount of games. Whatever the case may be, our goal is to maximize both performance and success."
      },
      {
        question: "What If I Reach A New Rank And Still Have Duo Games Remaining?",
        answer: "In ranks below Diamond we play one division above the initial rank. In Diamond+, net wins are only valid for the purchased division."
      },
      {
        question: "In Which Game Mode Are Duo Games Played?",
        answer: "Duo Games, being a ranked service, can only be played in Competitive Queue."
      },
      {
        question: "Can I Purchase Duo Games Before My Placements Are Complete?",
        answer: "Only accounts with all placements completed are eligible for Duo Games."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, unless you want to queue in the same ranking mode as the bought service. Other than that, schedule it in the order chat with your booster."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un service de boosting de parties en duo?",
        answer: "Les parties en duo sont un service de boosting d\'elo qui vous permet de jouer aux côtés d\'un de nos boosters pour un nombre déterminé de parties."
      },
      {
        question: "Combien de parties vais-je gagner?",
        answer: "Ce service ne garantit pas les victoires mais plutôt un certain nombre de parties. Quoi qu\'il en soit, notre objectif est de maximiser les performances et la réussite."
      },
      {
        question: "Que se passe-t-il si j\'atteins un nouveau rang et qu\'il me reste encore des parties en duo?",
        answer: "Dans les rangs inférieurs à Diamant, nous jouons une division au-dessus du rang initial. En Diamant+, les victoires nettes ne sont valables que pour la division achetée."
      },
      {
        question: "Dans quel mode de jeu les parties en duo sont-elles jouées?",
        answer: "Les parties en duo, étant un service classé, peuvent être seulement jouées en mode Competitif."
      },
      {
        question: "Puis-je acheter des parties Duo avant que mes placements ne soient terminés?",
        answer: "Seuls les comptes dont tous les placements ont été effectués peuvent bénéficier des parties en duo."
      },
      {
        question: "Puis-je jouer pendant que la commande est active?",
        answer: "Oui, sauf si vous voulez jouer dans le même mode classé que le service acheté. Dans le cas contraire, planifiez-le dans le chat de commande avec votre booster."
      }
    ],
    de: [
      {
        question: "Was ist ein Duo Games Boosting-Service?",
        answer: "Duo Games ist ein Elo-Boosting-Service, der es dir ermöglicht, zusammen mit einem unserer Booster für eine bestimmte Anzahl von Spielen zu spielen."
      },
      {
        question: "Wie viele Spiele werde ich gewinnen?",
        answer: "Dieser Service garantiert keine Siege, sondern stellt eine bestimmte Anzahl von Spielen zur Verfügung. Trotzdem ist es unser Ziel, sowohl die Leistung als auch den Erfolg zu maximieren."
      },
      {
        question: "Was ist, wenn ich einen neuen Rang erreiche und noch Duo-Spiele übrig habe?",
        answer: "In Rängen unterhalb von Diamond spielen wir eine Division über dem ursprünglichen Rang. In Diamond+ sind die Spiele nur für die gekaufte Division gültig."
      },
      {
        question: "In welchem Spielmodus werden die Duo-Spiele gespielt?",
        answer: "Da es sich bei Duo Games um einen Ranglistendienst handelt, können sie nur in der Competitive Queue gespielt werden."
      },
      {
        question: "Kann ich Duo-Spiele kaufen, bevor meine Platzierungen abgeschlossen sind?",
        answer: "Nur Konten, bei denen alle Platzierungen abgeschlossen sind, sind für Duo Games zugelassen."
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, es sei denn, du möchtest im gleichen Ranking-Modus wie der gekaufte Dienst spielen. Ansonsten planst du das mit deinem Booster im Auftragschat."
      }
    ],
    pt: [
      {
        question: "O Que É Um Serviço De Boost De Duo Games?",
        answer: "Duo Games é um serviço de elo boosting que permite que tu jogues com um dos nossos boosters por um número determinado de jogos."
      },
      {
        question: "Quantos jogos eu vou ganhar?",
        answer: "Este serviço não garante vitórias, mas fornece uma quantidade específica de jogos. O nosso objetivo é maximizar tanto a performance quanto o sucesso."
      },
      {
        question: "E se eu alcançar um novo rank e ainda tiver Jogos em Duo restantes?",
        answer: "Nos ranks abaixo de Diamond, jogamos uma divisão acima do rank inicial. Em Diamond+, as vitórias líquidas são válidas apenas para a divisão comprada."
      },
      {
        question: "Em Qual Modo De Jogo Os Duo Games São Jogados?",
        answer: "Os Duo Games, sendo um serviço ranked, só podem ser jogados em modo competitivo."
      },
      {
        question: "Posso Comprar Duo Games Antes De Terminar Os Meus Placements?",
        answer: "Somente contas com todos os placements completos são elegíveis para Duo Games."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, a menos que queiras fazê-lo no mesmo modo de jogo do serviço comprado. Excepto isso, basta falares e agendares com o teu booster."
      }
    ],
    es: [
      {
        question: "¿Qué es el servicio Boost de Duo Games?",
        answer: "Duo Games es un servicio de boosting de elo que te permite jugar junto a uno de nuestros boosters durante un número determinado de partidas."
      },
      {
        question: "¿Cuántas partidas ganaré?",
        answer: "Este servicio no garantiza victorias, sino que proporciona una cierta cantidad de partidos. Sea como sea, nuestro objetivo es maximizar tanto el rendimiento como el éxito."
      },
      {
        question: "¿Qué pasa si alcanzo un nuevo rango y aún me quedan partidas Duo?",
        answer: "En rangos inferiores a Diamond se juega una división por encima del rango inicial. En Diamond+, las victorias netas solo son válidas para la división adquirida."
      },
      {
        question: "¿En qué modo de juego se juega a dúo?",
        answer: "Duo Games, al ser un servicio clasificado, sólo puede jugarse en la Competitive Queue."
      },
      {
        question: "¿Puedo comprar Duo Games antes de que se completen mis clasificaciones?",
        answer: "Sólo las cuentas con todas las clasificaciones completadas son elegibles para Duo Games."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, a menos que quieras hacer cola en el mismo modo de clasificación que el servicio comprado. Aparte de eso, prográmalo en el chat de órdenes con tu booster."
      }
    ]
  }

  private page = {
    title: {
      en: "Valorant Boosting - Duo Games Boosting for Valorant",
      fr: "Boosting Valorant - Boosting pour parties en duo sur Valorant",
      de: "Valorant Boosting - Duo Games Boosting für Valorant",
      pt: "Valorant Boosting - Boost de Jogos em Duo para Valorant",
      es: "Valorant Boosting - Boosting de Duo Games para Valorant",
    },
    metaDescription: {
      en: "The perfect option for you to improve your MMR and skill in Valorant. Affordable, fast, and secure. Plus, we offer tips and tricks to help you perform better.",
      fr: "L\'option parfaite pour améliorer votre MMR et compétences sur Valorant. Abordable, rapide et sécurisé. De plus, nous offrons des conseils et des astuces pour vous aider à améliorer vos performances.",
      de: "Die perfekte Option, um dein MMR und dein Können in Valorant zu verbessern. Günstig, schnell und sicher. Tipps und Tricks, wie du noch besser werden kannst, bieten wir dir ebenfalls an.",
      pt: "A opção perfeita para melhorares o teu MMR e habilidades no Valorant. Acessível, rápido e seguro. Além disso, oferecemos dicas e truques para ajudar-te a melhorar.",
      es: "La opción perfecta para mejorar tu MMR y habilidad en Valorant. Asequible, rápida y segura. Además, te ofrecemos consejos y trucos para ayudarte a rendir mejor.",
    }
  }


  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        },
      );
    });
  }
}